//https://github.com/Porgramming-Hero-web-course/simple-react-Shahed70
import './App.css';
import playerlist from '../../playerlist.json'
import Header from '../Header/Header';
import Main from '../Main/Main';
import Footer from '../Footer/Footer';
function App() {
  return (
    <>
      <Header></Header>
      <Main playerlist={playerlist}></Main>
      <Footer></Footer>
    </>
  );
}

export default App;
